import { Directory, Filesystem } from "@capacitor/filesystem";
import { Share } from "@capacitor/share";

export async function shareNativeFile(base64Data: string, fileName: string) {
  const result = await Filesystem.writeFile({
    data: base64Data,
    path: fileName,
    recursive: true,
    directory: Directory.Cache,
    // The encoding to write the file in. If not provided, data is written as base64 encoded. Pass Encoding.UTF8 to write data as string
    encoding: undefined, // !important since data is in base64
  });

  if (!result.uri) throw new Error("Download failed, please try again later");

  const fileLocalPath = result.uri.startsWith("file://")
    ? result.uri
    : `file://${result.uri}`;

  try {
    await Share.share({
      url: fileLocalPath,
    });
  } catch (e) {
    // nothing to do when user cancels it
  }
}
